import { toggleReconnectVisible } from 'js/components/system/App/store/actions';

export const onServerReconnect = ({ dispatch, isReconnectVisible }) => {
    dispatch(toggleReconnectVisible(isReconnectVisible));
};
